import React from "react";
import { socialOptions } from "../../util/socials";
import { FaGlobe } from "react-icons/fa"; // Generic website icon fallback
import Icon from "../Icon/Icon";
import websiteIcon from "../../assets/icons/website.svg";
import { Link } from "react-router-dom";
import { getSocialOption } from "../../util/styleUtils";

const SocialButton = ({ social, btnClassName,className, eventType, style, labelMode, ...rest }) => {
  const { platform, link } = social;

  if(!link) return null;

  // Get the icon and label based on the rules
  const { icon,rawIcon, id :label } = getSocialOption(link);
  const normalizeUrl = (url) => {
    if (!/^https?:\/\//i.test(url)) {
      return `https://${url}`;
    }
    return url;
  };

  // icon only (event details action row): same boxed kit button as the actions next to it
  if (labelMode === "hidden") {
    return (
      <a
        href={normalizeUrl(link)}
        target="_blank"
        rel="noreferrer"
        aria-label={label}
        title={label}
        className={`inyc-icon-btn is-secondary is-md is-box event-details-action-btn ${className || ""}`}
      >
        {rawIcon({ size: 20, color: "currentColor" })}
      </a>
    );
  }

  // with a label (named socials on event details, media links that can't embed):
  // kit secondary button as a link, icon + the platform / display name
  const text = (platform || "").trim() || label;
  return (
    <a
      href={normalizeUrl(link)}
      target="_blank"
      rel="noreferrer"
      style={style}
      className={`inyc-btn is-secondary ${labelMode === "row" ? "is-lg event-details-named-social" : "is-md"} ${className || ""}`}
    >
      {rawIcon({ size: 16, color: "currentColor" })}
      <span className="truncate">{text}</span>
    </a>
  );
};

export default SocialButton;
